import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { OAuthService } from "angular-oauth2-oidc";
import { AuthBaseService } from "core-kit";
import { AccountService } from "./account.service";

@Injectable()
export class AuthService extends AuthBaseService {
  constructor(protected oAuthService: OAuthService, protected accountSvc: AccountService, private router: Router) {
    super(oAuthService, accountSvc);
  }

  get isLoggedIn(): boolean {
    return this.accountSvc.isLoggedIn;
  }

  protected postLogoutActions(): void {
    this.router.navigate(["/home"]);
  }
}
